let IDX = 0;
export const generateUID = (): string => `id_${IDX++}`;
